import { useDispatch } from "react-redux";
import { useState } from "react";
// -------------------------------------------------------------
import {
  generateReport,
  calculateRollforward,
  calculateAging,
  calculateAny,
  retrieveAll,
} from "Redux/data/actions";

const dummy = () => {};

// -------------------------------------------------------------
// -------------------------------------------------------------
const RunAnalysis = ({ onClose, parameters, isUpdate }) => {
  const dispatch = useDispatch();

  isUpdate = false;
  
  const [running, setRunning] = useState(false);
  const [status, setStatus] = useState("analysis");
  const [statuses, setStatuses] = useState({
    aging: "waiting",
    rollforward: "waiting",
    supplierMetrics: "waiting",
    invoiceEligibility: "waiting",
    criteria: "waiting",
    performanceRatios: "waiting",
    advanceRates: "waiting",
  });

  const runAnalysis = async () => {
    setRunning(true);
    setStatuses({
      aging: "waiting",
      rollforward: "waiting",
      supplierMetrics: "waiting",
      invoiceEligibility: "waiting",
      criteria: "waiting",
      performanceRatios: "waiting",
      advanceRates: "waiting",
    });

    if (!isUpdate) {
      setStatuses((prevStatuses) => ({
        ...prevStatuses,
        aging: "running",
      }));
      await dispatch(calculateAging(dummy));

      setStatuses((prevStatuses) => ({
        ...prevStatuses,
        aging: "done",
        rollforward: "running",
      }));
      await dispatch(calculateRollforward(dummy));
    }

    setStatuses((prevStatuses) => ({
      ...prevStatuses,
      rollforward: "done",
      supplierMetrics: "running",
    }));
    await dispatch(calculateAny("supplier", dummy));

    setStatuses((prevStatuses) => ({
      ...prevStatuses,
      supplierMetrics: "done",
      invoiceEligibility: "running",
    }));
    await dispatch(calculateAny("invoice", dummy));

    setStatuses((prevStatuses) => ({
      ...prevStatuses,
      invoiceEligibility: "done",
      performanceRatios: "running",
    }));
    await dispatch(calculateAny("performance", dummy));

    setStatuses((prevStatuses) => ({
      ...prevStatuses,
      performanceRatios: "done",
      criteria: "running",
    }));
    await dispatch(calculateAny("criteria", dummy));

    setStatuses((prevStatuses) => ({
      ...prevStatuses,
      criteria: "done",
      advanceRates: "running",
    }));
    await dispatch(calculateAny("advance", dummy));
    await dispatch(calculateAny("dashboard", dummy));
    await dispatch(retrieveAll(dummy));

    setStatuses((prevStatuses) => ({ ...prevStatuses, advanceRates: "done" }));
    await dispatch(generateReport(dummy));

    setRunning(false);
    setStatus("done");
  };

  if (status !== "analysis")
    return <Done onClose={onClose} parameters={parameters} />;

  return (
    <div className={`modal is-active`}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Generate Analysis</p>
          <button className="delete" aria-label="close" onClick={onClose} />
        </header>
        <section className="modal-card-body">
          <div style={{ margin: "0 0 16px 0" }}>
            <p>This can take a while...</p>
            <p>
              Closing this window while running can lead to inconsistent
              outputs.
            </p>
          </div>
          <div className="box">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
              }}
            >
              {!isUpdate && (
                <>
                  <AnalysisComponent
                    headline="Aging Timeseries"
                    icon="fa-duotone fa-timeline"
                    status={statuses.aging}
                  />
                  <AnalysisComponent
                    headline="Rollforward Analysis"
                    icon="fa-duotone fa-code-compare"
                    status={statuses.rollforward}
                  />
                </>
              )}

              <AnalysisComponent
                headline="Supplier Metrics"
                icon="fa-boxes-packing"
                status={statuses.supplierMetrics}
              />
              <AnalysisComponent
                headline="Invoice Eligibility"
                icon="fa-file-invoice"
                status={statuses.invoiceEligibility}
              />
              <AnalysisComponent
                headline="Performance Ratios"
                icon="fa-percent"
                status={statuses.performanceRatios}
              />
              <AnalysisComponent
                headline="Supplier Criteria"
                icon="fa-badge-check"
                status={statuses.criteria}
              />
              <AnalysisComponent
                headline="Advance Rates"
                icon="fa-file-invoice-dollar"
                status={statuses.advanceRates}
              />
            </div>
          </div>
        </section>
        <footer className="modal-card-foot">
          <button
            className={`button ${running ? "is-loading" : ""}`}
            onClick={runAnalysis}
          >
            Start Analysis
          </button>
        </footer>
      </div>
    </div>
  );
};

export default RunAnalysis;

const AnalysisComponent = ({ headline, icon, status }) => {
  const icons = {
    waiting: "fa-hourglass-start",
    done: "fa-check-circle",
    running: "fa-gear fa-spin",
  };
  const notifications = {
    done: "is-success",
    running: "is-light",
    waiting: "is-light",
  };

  return (
    <div
      style={{
        display: "flex",
        backgroundColor: "#ededed",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-around",
        margin: "8px",
        padding: "4px 16px",
        borderRadius: 16,
      }}
    >
      <div>
        <i className={`fa-duotone ${icon}`} style={{ fontSize: "1.6em" }}></i>
      </div>
      <div style={{ flex: 3, margin: 16 }}>{headline}</div>
      <div className={`tag ${notifications[status]}`}>
        <i className={`fa-duotone ${icons[status]}`}></i>
      </div>
    </div>
  );
};

const Done = ({ onClose, parameters }) => {
  const dispatch = useDispatch();
  return (
    <div className={`modal is-active`}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Generate Analysis</p>
        </header>
        <section className="modal-card-body">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ width: "170px" }}>
              <div
                className="notification is-success"
                style={{ textAlign: "center" }}
              >
                <i
                  className="fa-duotone fa-check-circle"
                  style={{ fontSize: "3em" }}
                />

                <div
                  className="title is-5"
                  style={{ color: "#fff", marginTop: "16px" }}
                >
                  Analysis was completed
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer className="modal-card-foot">
          <button
            className="button"
            onClick={() => {
              dispatch({ type: "SET_PROJECT_PARAMETERS", parameters });
              dispatch({ type: "SET_PROJECT_ANALYSIS", hasAnalysis: true });
              dispatch({ type: "SET_PRE_OR_POST", preOrPost: "post" });
              onClose();
            }}
          >
            Ok
          </button>
        </footer>
      </div>
    </div>
  );
};
